import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Switch,
  TextField,
  FormControlLabel,
  CircularProgress,
  Autocomplete,
} from "@mui/material";
import api from "../../../../services/api";

const StackingConfigFields = ({ form, setForm }) => {
  const [availableRules, setAvailableRules] = useState([]);
  const [loading, setLoading] = useState(true);

  const stacking = form.stacking || {};

  useEffect(() => {
    const fetchRules = async () => {
      try {
        const res = await api.get("/admin/discount-rules");
        setAvailableRules(res.data || []);
      } catch (err) {
        console.error("Failed to fetch discount rules", err);
      } finally {
        setLoading(false);
      }
    };

    fetchRules();
  }, []);

  const handleChange = (key, value) => {
    setForm((prev) => ({
      ...prev,
      stacking: {
        ...prev.stacking,
        [key]: value,
      },
    }));
  };

  return (
    <Box mt={3}>
      <Typography variant="subtitle1" gutterBottom>
        Stacking Rules
      </Typography>

      <FormControlLabel
        control={
          <Switch
            checked={stacking.exclusive || false}
            onChange={(e) => handleChange("exclusive", e.target.checked)}
          />
        }
        label="Exclusive (cannot stack with other discounts)"
      />

      <TextField
        fullWidth
        label="Priority"
        type="number"
        value={stacking.priority || ""}
        onChange={(e) => handleChange("priority", Number(e.target.value))}
        sx={{ mt: 2 }}
        helperText="Higher priority discounts are applied first (0 = lowest)"
      />

      <Autocomplete
        multiple
        options={availableRules}
        loading={loading}
        getOptionLabel={(option) =>
          typeof option === "string" ? option : option.name
        }
        value={availableRules.filter((rule) =>
          (stacking.conflictsWith || []).includes(rule._id)
        )}
        onChange={(e, newValue) =>
          handleChange(
            "conflictsWith",
            newValue.map((rule) => rule._id)
          )
        }
        isOptionEqualToValue={(option, value) => option._id === value._id}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Conflicts With (Discount Rules)"
            placeholder="Start typing to search"
            helperText="Select discounts this rule cannot stack with"
            sx={{ mt: 2 }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? <CircularProgress size={18} /> : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </Box>
  );
};

export default StackingConfigFields;
